import React from 'react';
import {CustomInput} from 'reactstrap';
// import {LazyLoadImage} from 'react-lazy-load-image-component';
import {textTruncateByLength} from 'utils/other';
import ImageWithFallback from 'components/ImageWithFallback';
import Tooltip from 'components/Tooltip';

const EntityFilterListItem = ({entity, activeEntities, handleEntitySelect, updating}) => {

    return (
        <div className="saved-search-entity-list-item">
            <Tooltip placement="bottom" wide tooltip={`Show/hide results`}>
                <CustomInput
                    id={entity.id}
                    type="checkbox"
                    className="saved-search-entity-list-item__checkbox"
                    checked={activeEntities.includes(entity.id)}
                    disabled={updating}
                    onChange={() => handleEntitySelect(entity.id)}
                />
            </Tooltip>
            <div className="saved-search-entity-list-item__logo">
                {entity.logoUrl ?
                    <ImageWithFallback
                        height={40} width={40}
                        itemTitle={entity.title}
                        fallbackColor={entity.color}
                        src={entity.logoUrl}
                        className="icon-with-letter"
                    />
                    :
                    <div className="icon-with-letter" style={{backgroundColor: entity.color, fontSize: '24px'}}>
                        {entity.title && entity.title[0].toUpperCase()}
                    </div>
                }
            </div>
            <div className="saved-search-entity-list-item__info">
                <div>
                    {textTruncateByLength(entity.title, 30)}
                </div>
                <div>
                    {entity.domain ? entity.domain : ''}
                </div>
            </div>
        </div>
    );
};

export default EntityFilterListItem;
